module.exports = __webpack_public_path__ + "c9b07754404120f6a56146da0346d6e1.png";